// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".el-dialog__wrapper .el-dialog__footer,.el-dialog__wrapper .el-dialog__header{padding:16px}.el-dialog__wrapper .el-dialog__body{padding:0 16px 0 16px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
